
/* injects from baggage-loader */

'use strict';

import AccountComponent from './account.component';
import './account.scss';

// Load child states
import AccountHomePageModule from './home/account.home.module';
import AccountDocumentsPageModule from './documents/account.documents.module';
import AccountInvestmentsPageModule from './investments/account.investments.module';
import AccountSettingsPageModule from './settings/account.settings.module';
import AccountProjectsPageModule from './projects/account.projects.module';

const AccountPageModule = angular.module('account-module', [
  'ui.router',

  // Child states
  AccountHomePageModule.name,                 // Home (investments)
  AccountDocumentsPageModule.name,            // Documents
  AccountInvestmentsPageModule.name,          // List my investments (Donations)
  AccountSettingsPageModule.name,             // Account settings
  AccountProjectsPageModule.name,             // My Projects (raises)

])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account', {
        url: '/account',
        component: 'account',
        // Requires valid login to view
        protected: true,
        // Abstract parent of children states, cannot be visited directly
        abstract: true,
        // Resolve promises into controller bindings, see component for bindings
        resolve: {
          profile: function (Profiles) {
            try {
              return Profiles.fetchOwn();
            } catch (err) {
              throw err;
            }
          }
        }
      });
  })
  .component('account', new AccountComponent());

export default AccountPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/account.module.js